export default String.raw`
{% assign autoPlayOn = 'no' -%}
{% if include == "brands" -%}
    {% assign content = manufacturer-brand.Brands -%}
    {% assign heading = translations.Brands -%}
    {% assign link = config.DefinedPages.Brands.Url -%}
    {% assign timer = '' -%}
    {% if settings.brandsSliderAutoplayToggle == 'yes' -%}
        {% assign autoPlayOn = settings.brandsSliderAutoplayToggle -%}
        {% assign timer = settings.brandsSliderAutoplaySpeed -%}
    {% endif -%}
    {% assign hover = settings.brandsSliderAnimationOnHover -%}
{% else -%}
    {% assign content = manufacturer-brand.Manufacturers -%}
    {% assign heading = translations.Manufacturers -%}
    {% assign link = config.DefinedPages.Manufacturers.Url -%}
    {% assign timer = '' -%}
    {% if settings.manufacturersSliderAutoplayToggle == 'yes' -%}
        {% assign autoPlayOn = settings.manufacturersSliderAutoplayToggle -%}
        {% assign timer = settings.manufacturersSliderAutoplaySpeed -%}
    {% endif -%}
    {% assign hover = settings.manufacturersSliderAnimationOnHover -%}
{% endif -%}

{% assign contentSize = content | Size -%}

{% if contentSize > 0 -%}
    {% assign isImg = false -%}
    {% for item in content -%}
        {% if item.Image -%}
            {% assign isImg = true -%}
            {% break -%}
        {% endif -%}
    {% endfor -%}

    {% if isImg -%}
        <section class="companies" data-hover="{{hover}}">
            <div class="companies__header">
                <h2>{{ heading }}</h2>
                <a href="{{ page.BaseHref }}{{ link }}">
                    {{ translations.ShowAll }}
                    <svg><use href='css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-right-{{ settings.iconStyle }}'></use></svg>
                </a>
            </div>
            <div class="companies__container">
                <div aria-label="{{translations.PrevSlide}}" role="button" tabindex="0" class="companies__prev arrow shadowed {{ include }}__prev">
                    <svg class="arrow__icon">
                        <use href='css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-right-{{ settings.iconStyle }}'></use>
                    </svg>
                </div>
                <div aria-label="{{translations.NextSlide}}" role="button" tabindex="0" class="companies__next arrow shadowed {{ include }}__next">
                    <svg class="arrow__icon">
                        <use href='css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-right-{{ settings.iconStyle }}'></use>
                    </svg>
                </div>
                <div tabindex="-1" class="companies__swiper {{ include }}__swiper" data-timer="{{timer}}">
                    {% assign slidesNumber = 0 -%}
                    {% for logo in content -%}
                        {% if logo.Image -%}
                            {% assign slidesNumber = slidesNumber | Plus: 1 -%}
                        {% endif -%}
                    {% endfor -%}
                    <div class="companies__wrapper swiper-wrapper" data-len="{{ slidesNumber }}">
                        {% for logo in content -%}
                            {% if logo.Image -%}
                                {% if logo.Heading != null -%}
                                    {% assign title = logo.Heading -%}
                                {% else -%}
                                    {% assign title = logo.Name -%}
                                {% endif -%}
                                <div class="companies__slide swiper-slide">
                                    <a href="{{ page.BaseHref }}{{ logo.Url }}">
                                        <div>
                                            {% if logo.Image.Id > 0 and logo.Image.Link != null -%}
                                                {% capture imageLink -%}img/compact/{{logo.Image.Id}}/{{logo.Image.Link}}{% endcapture -%}
                                            {% elsif logo.Image.ExternalUrl != null -%}
                                                {% capture imageLink -%}{{ logo.Image.ExternalUrl }}{% endcapture -%}
                                            {% else -%}
                                                {% capture imageLink -%}css/img/img-placeholder.jpg{% endcapture -%}
                                            {% endif -%}
                                            <img loading="lazy" src="{{ imageLink }}" alt="{{ logo.Image.Alt | H }}">
                                            <span {% if hover == 'no'-%} style="visibility: hidden;" {% endif -%}>{{ title | H }}</span>
                                        </div>
                                    </a>
                                </div>
                            {% endif -%}
                        {% endfor -%}
                    </div>
                    <div aria-label="{{translations.PauseSlide}}" role="button" tabindex="0" class="{{ include }}-pause-button swiper-button-pause">
                        <svg class="pause-icon">
                            <use href='css/img/fontawesome-icons.svg?v={{lqTS}}#pause-circle-{{ settings.iconStyle }}'></use>
                        </svg>
                    </div>
                </div>
            </div>
        </section>
    {% endif -%}
{% endif -%}
`